module.exports = __webpack_public_path__ + "static/img/YD50.1d76350.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/YD50.png
// module id = azyx
// module chunks = 2